import React from "react";
import EphemeralData from "./EphemeralData";
import RuleModuleDetails from "./RuleModuleDetails";
import { RuleModule } from "../../classes/RuleModule";
import { RuleModuleContext } from "../../contexts/RuleModuleContext";
import { RulesContext } from "../../contexts/RulesContext";

export default function ReferenceSheet() {
  const { allRuleModules } = React.useContext(RulesContext);
  const sections = allRuleModules().map((module: RuleModule) => {
    return (
      <RuleModuleContext.Provider
        value={module}
        key={`module-${module.dataTest()}`}
      >
        <RuleModuleDetails />
      </RuleModuleContext.Provider>
    );
  });
  return (
    <>
      <EphemeralData />
      {sections}
    </>
  );
}
